import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 70px;
  background-color: ${props => props.theme.colors.primary};
  padding: 0 50px 0 92px;
  width: 100%;
  z-index: ${props => props.theme.zIndexes.header.headerWrapper};
  white-space: nowrap;
  text-align: right;

  @media (max-width: 500px) {
    padding-left: 15px;
  }

  .search-input {
    max-width: 400px;
    float: right;
    margin: 0 30px;
    top: 50%;
    transform: translateY(-50%);

    max-width: 400px;
    float: right;
    margin: 0 30px;
    top: 50%;
    transform: translateY(-50%);
  }
`



// WEBPACK FOOTER //
// ./src/Components/Header/HeaderWrapper/index.js